// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const CHECKOUT_ORDER = 'CHECKOUT_ORDER';
export const CHECKOUT_ORDER_SUCCESS = 'CHECKOUT_ORDER_SUCCESS';
export const CHECKOUT_ORDER_FAILED = 'CHECKOUT_ORDER_FAILED';

export const DELETE_SELECTED_ACCESSORY = 'DELETE_SELECTED_ACCESSORY';
export const DELETE_SELECTED_PARENT = 'DELETE_SELECTED_PARENT';

export const GET_JARVIS_DATA = 'GET_JARVIS_DATA';
export const GET_JARVIS_DATA_FAILED = 'GET_JARVIS_DATA_FAILED';
export const GET_JARVIS_DATA_SUCCESS = 'GET_JARVIS_DATA_SUCCESS';

export const GET_PART_INFO = 'GET_PART_INFO';
export const GET_PART_INFO_FAIL = 'GET_PART_INFO_FAIL';
export const GET_PART_INFO_SUCCESS = 'GET_PART_INFO_SUCCESS';

export const PUT_PART_INFO = 'PUT_PART_INFO';
export const PUT_PART_INFO_FAIL = 'PUT_PART_INFO_FAIL';
export const PUT_PART_INFO_SUCCESS = 'PUT_PART_INFO_SUCCESS';

export const GET_REPAIR_OFFER = 'GET_REPAIR_OFFER';

export const GET_REGISTER_INFO_DATA = 'GET_REGISTER_INFO_DATA';
export const GET_REGISTER_INFO_DATA_SUCCESS = 'GET_REGISTER_INFO_DATA_SUCCESS';
export const GET_REGISTER_INFO_DATA_FAIL = 'GET_REGISTER_INFO_DATA_FAIL';

export const GET_REGISTRATION_SUCCESS = 'GET_REGISTRATION_SUCCESS';
export const GET_REGISTRATION_FAIL = 'GET_REGISTRATION_FAIL';

export const GET_SHIPPING_ADDRESS_DATA = 'GET_SHIPPING_ADDRESS_DATA';
export const GET_SHIPPING_ADDRESS_DATA_SUCCESS =
    'GET_SHIPPING_ADDRESS_DATA_SUCCESS';

export const GET_SHIPPING_DEVICE_OFFER_DATA = 'GET_SHIPPING_DEVICE_OFFER_DATA';
export const GET_SHIPPING_DEVICE_OFFER_DATA_SUCCESS =
    'GET_SHIPPING_DEVICE_OFFER_DATA_SUCCESS';

export const GET_SHIPPING_ACCESSORY_OFFER_DATA =
    'GET_SHIPPING_ACCESSORY_OFFER_DATA';
export const GET_SHIPPING_ACCESSORY_OFFER_DATA_SUCCESS =
    'GET_SHIPPING_ACCESSORY_OFFER_DATA_SUCCESS';

export const PURCHASE_ORDER = 'PURCHASE_ORDER';
export const PURCHASE_ORDER_SUCCESS = 'PURCHASE_ORDER_SUCCESS';
export const PURCHASE_ORDER_FAILED = 'PURCHASE_ORDER_FAILED';

export const SAVE_BILLING_ADDRESS = 'SAVE_BILLING_ADDRESS';

export const SAVE_REPAIR_OFFER = 'SAVE_REPAIR_OFFER';
export const SAVE_USER_DEVICE_AND_ACCESSORY_SELECTION =
    'SAVE_USER_DEVICE_AND_ACCESSORY_SELECTION';

export const SAVE_ZIP_CODE_DATA = 'SAVE_ZIP_CODE_DATA';
export const SAVE_SAFETY_FORM_DATA = 'SAVE_SAFETY_FORM_DATA';

export const SAVE_SELECTED_OFFER = 'SAVE_SELECTED_OFFER';

export const GET_SELECTED_SHIPPING_OFFER_DATA =
    'GET_SELECTED_SHIPPING_OFFER_DATA';
export const GET_SELECTED_SHIPPING_OFFER_DATA_SUCCESS =
    'GET_SELECTED_SHIPPING_OFFER_DATA_SUCCESS';

export const UPDATE_CREATE_ORDER_PROGRESS = 'UPDATE_CREATE_ORDER_PROGRESS';
export const UPDATE_REACTIVATE_ORDER_STATUS = 'UPDATE_REACTIVATE_ORDER_STATUS';

export const PURCHASE_ON_DEMAND_ORDER = 'PURCHASE_ON_DEMAND_ORDER';
export const PURCHASE_ON_DEMAND_ORDER_SUCCESS = 'PURCHASE_ON_DEMAND_ORDER_SUCCESS';
export const PURCHASE_ON_DEMAND_ORDER_FAILED = 'PURCHASE_ON_DEMAND_ORDER_FAILED';
export const REASON_FOR_NOT_SELECTING_OFFERS = 'REASON_FOR_NOT_SELECTING_OFFERS';

export const SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS = 'SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS';
export const SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS_SUCCESS = 'SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS_SUCCESS';
export const SAVE_CUSTOMER_COMMENTS = 'SAVE_CUSTOMER_COMMENTS';
export const SAVE_CUSTOMER_COMMENTS_SUCCESS = 'SAVE_CUSTOMER_COMMENTS_SUCCESS';

export const SAVE_TRAVEL_SR_OUTCOME = 'SAVE_TRAVEL_SR_OUTCOME';
export const SAVE_SOFTWARE_ORDER_DETAILS = 'SAVE_SOFTWARE_ORDER_DETAILS';

export const {
    checkoutOrder,
    checkoutOrderFailed,
    checkoutOrderSuccess,

    deleteSelectedAccessory,
    deleteSelectedParent,

    getPartInfo,
    getPartInfoFail,
    getPartInfoSuccess,

    putPartInfo,
    putPartInfoFail,
    putPartInfoSuccess,

    getRepairOffer,

    getShippingAccessoryOfferData,
    getShippingAccessoryOfferDataSuccess,

    getShippingAddressData,
    getShippingAddressDataSuccess,

    getShippingDeviceOfferData,
    getShippingDeviceOfferDataSuccess,

    purchaseOrder,
    purchaseOrderFailed,
    purchaseOrderSuccess,

    saveBillingAddress,

    saveRepairOffer,
    saveUserDeviceAndAccessorySelection,
    saveZipCodeData,
    saveSafetyFormData,

    getRegisterInfoData,
    getRegisterInfoDataSuccess,
    getRegisterInfoDataFail,

    getJarvisData,
    getJarvisDataFailed,
    getJarvisDataSuccess,

    getRegistrationSuccess,
    getRegistrationFail,
    saveSelectedOffer,
    
    getSelectedShippingOfferData,

    getSelectedShippingOfferDataSuccess,

    updateCreateOrderProgress,

    updateReactivateOrderStatus,

    purchaseOnDemandOrder,
    purchaseOnDemandOrderFailed,
    purchaseOnDemandOrderSuccess,
    reasonForNotSelectingOffers,

    saveCustomerServiceLocationAddress,
    saveCustomerServiceLocationAddressSuccess,
    saveCustomerComments,
    saveCustomerCommentsSuccess,

    saveTravelSrOutcome,

    saveSoftwareOrderDetails,

} = createActions(
    CHECKOUT_ORDER,
    CHECKOUT_ORDER_FAILED,
    CHECKOUT_ORDER_SUCCESS,

    DELETE_SELECTED_ACCESSORY,
    DELETE_SELECTED_PARENT,

    GET_PART_INFO,
    GET_PART_INFO_FAIL,
    GET_PART_INFO_SUCCESS,

    PUT_PART_INFO,
    PUT_PART_INFO_FAIL,
    PUT_PART_INFO_SUCCESS,

    GET_REPAIR_OFFER,

    GET_SHIPPING_ACCESSORY_OFFER_DATA,
    GET_SHIPPING_ACCESSORY_OFFER_DATA_SUCCESS,

    GET_SHIPPING_ADDRESS_DATA,
    GET_SHIPPING_ADDRESS_DATA_SUCCESS,

    GET_SHIPPING_DEVICE_OFFER_DATA,
    GET_SHIPPING_DEVICE_OFFER_DATA_SUCCESS,

    PURCHASE_ORDER,
    PURCHASE_ORDER_FAILED,
    PURCHASE_ORDER_SUCCESS,

    SAVE_BILLING_ADDRESS,
    
    SAVE_REPAIR_OFFER,
    SAVE_USER_DEVICE_AND_ACCESSORY_SELECTION,

    SAVE_ZIP_CODE_DATA,
    SAVE_SAFETY_FORM_DATA,

    DELETE_SELECTED_PARENT,
    DELETE_SELECTED_ACCESSORY,

    GET_REGISTER_INFO_DATA,
    GET_REGISTER_INFO_DATA_SUCCESS,
    GET_REGISTER_INFO_DATA_FAIL,

    GET_JARVIS_DATA,
    GET_JARVIS_DATA_FAILED,
    GET_JARVIS_DATA_SUCCESS,

    GET_REGISTRATION_SUCCESS,
    GET_REGISTRATION_FAIL,

    SAVE_SELECTED_OFFER,

    GET_SELECTED_SHIPPING_OFFER_DATA,
    GET_SELECTED_SHIPPING_OFFER_DATA_SUCCESS,

    UPDATE_CREATE_ORDER_PROGRESS,

    UPDATE_REACTIVATE_ORDER_STATUS,

    PURCHASE_ON_DEMAND_ORDER,
    PURCHASE_ON_DEMAND_ORDER_FAILED,
    PURCHASE_ON_DEMAND_ORDER_SUCCESS,
    REASON_FOR_NOT_SELECTING_OFFERS,

    SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS,
    SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS_SUCCESS,
    SAVE_CUSTOMER_COMMENTS,
    SAVE_CUSTOMER_COMMENTS_SUCCESS,

    SAVE_TRAVEL_SR_OUTCOME,

    SAVE_SOFTWARE_ORDER_DETAILS
);

export const RESET_ORDER_DATA = 'RESET_ORDER_DATA';
export const RESET_PARTS = 'RESET_PARTS';
export const RESET_PARTS_STATUS = 'RESET_PARTS_STATUS';
export const RESET_REGISTRATION_DATA = 'RESET_REGISTRATION_DATA';
export const RESET_SELECTED_OFFER = 'RESET_SELECTED_OFFER';
export const RESET_SELECTED_SHIPPING_OFFER_DATA = 'RESET_SELECTED_SHIPPING_OFFER_DATA';
export const RESET_SELECTED_SHIPPING_OFFER_DATA_SUCCESS = 'RESET_SELECTED_SHIPPING_OFFER_DATA_SUCCESS';
export const SECOND_SR_CREATION = 'SECOND_SR_CREATION';

export const {
    resetOrderData,
    resetParts,
    resetPartsStatus,
    resetRegistrationData,
    resetSelectedOffer,
    resetSelectedShippingOfferData,
    resetSelectedShippingOfferDataSuccess,
    secondSrCreation,
} = createActions(
    RESET_ORDER_DATA,
    RESET_PARTS,
    RESET_PARTS_STATUS,
    RESET_REGISTRATION_DATA,
    RESET_SELECTED_OFFER,
    RESET_SELECTED_SHIPPING_OFFER_DATA,
    RESET_SELECTED_SHIPPING_OFFER_DATA_SUCCESS,
    SECOND_SR_CREATION
);